import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import api from "../lib/api";

export default function Footer() {
  const [contact, setContact] = useState(null);
  useEffect(() => {
    api.get("/contact").then((r) => setContact(r.data)).catch(() => setContact({}));
  }, []);

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1F1F1F] border-t border-[#3a3a3a] mt-24"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img src="/logo.png" alt="Śląski Maker Space" className="h-20 w-auto mb-6"/>
          <p className="text-white/60 text-sm leading-relaxed">
            Otwarta pracownia kreatywna w Katowicach. Łączymy rzemiosło, technologię i społeczność.
          </p>
        </div>

        <div>
          <div className="kicker mb-4">Nawigacja</div>
          <ul className="space-y-2 text-sm">
            {[
              ["/", "Strona główna"],
              ["/warsztaty", "Warsztaty"],
              ["/dostep", "Dostęp do pracowni"],
              ["/o-nas", "O nas"],
              ["/regulamin", "Regulamin"],
              ["/kontakt", "Kontakt"],
            ].map(([to, l]) => (
              <li key={to}>
                <Link to={to} className="text-white/70 hover:text-[#FFCC00] transition-colors">
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div data-testid="footer-contact">
          <div className="kicker mb-4">Kontakt</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="text-[#FFCC00] mt-0.5 flex-shrink-0"/>
              <span>{contact?.address || "Plebiscytowa 15, 40-035 Katowice"}</span>
            </li>
            {contact?.phone && (
              <li className="flex items-start gap-2">
                <Phone size={16} className="text-[#FFCC00] mt-0.5 flex-shrink-0"/>
                <div className="flex flex-wrap gap-x-4 gap-y-1">
                  {contact.phone.split("\n").map((p, i) => (
                    <div key={i} className="whitespace-nowrap">{p}</div>
                  ))}
                </div>
              </li>
            )}
            {contact?.email && (
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-[#FFCC00]"/>
                <a href={`mailto:${contact.email}`} className="hover:text-[#FFCC00] break-all">{contact.email}</a>
              </li>
            )}
          </ul>
        </div>

        <div data-testid="footer-hours">
          <div className="kicker mb-4">Godziny otwarcia</div>
          <ul className="space-y-1 text-sm text-white/70 font-mono-acc">
            {(contact?.hours || []).map((h, i) => (
              <li key={i} className="flex justify-between gap-3">
                <span>{h.day}</span>
                <span className="text-white/50">{h.time}</span>
              </li>
            ))}
            {(!contact?.hours || contact.hours.length === 0) && (
              <li className="text-white/50">Wt, Cz — 17:00 – 20:00</li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#2f2f2f]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40 font-mono-acc uppercase">
          <span>© {new Date().getFullYear()} Śląski Maker Space — Wszystkie prawa zastrzeżone</span>
          <Link to="/admin/login" data-testid="admin-footer-link" className="hover:text-[#FFCC00]">Panel administratora</Link>
        </div>
      </div>
    </footer>
  );
}
